export default __webpack_public_path__ + "static/642127ffa9e874c709ee9e35c935ee56.png";